module.exports = __webpack_public_path__ + "static/img/6@2x.0e0ce757.png";